import React from 'react';

export interface Content {
  storageKey: string;
  image?: string;
  title: string;
  description: React.ReactNode;
  beta_module?: string;
}

export const contents: Content[] = [
  {
    storageKey: 'new-products-call',
    title: 'Descubra os novos lançamentos da Eduzz que vão escalar seu negócio digital!',
    description: (
      <>
        <p>Temos uma ótima notícia para você, produtor e estrategista digital!</p>
        <p>
          O ecossistema da Eduzz evoluiu e apresenta 4 novos recursos que vão <strong>revolucionar</strong> o seu negócio! Estamos empolgados em
          compartilhar cada detalhe sobre essas soluções que vão multiplicar as suas vendas! Confira agora os detalhes de todos os lançamentos:
        </p>
      </>
    ),
  },
  {
    storageKey: 'new-products-paglive',
    title: 'PagLive: A maquininha da Eduzz!',
    image: '/img/news/paglive.jpg',
    description: (
      <>
        <p>
          A PagLive é a revolução para o seu negócio! Agora, a maquininha da Eduzz estará ao seu lado, facilitando todas as suas vendas offline em
          eventos e mentorias.
        </p>
        <p>
          Em conjunto com a Blinket, você contará com praticidade e controle financeiro, enquanto suas vendas são contabilizadas diretamente no
          MyEduzz e você ainda pontua no Programa Elite.
        </p>
        <p>
          Conheça os detalhes sobre o PagLive{' '}
          <a href='https://orbita.eduzz.com/producer/news/info/260' target='_blank' rel='noopener noreferrer'>
            aqui
          </a>
          .
        </p>
      </>
    ),
  },
  {
    storageKey: 'new-products-checkout-global',
    title: 'Checkout Global e Multi Ofertas',
    image: '/img/news/checkout-global.jpg',
    description: (
      <>
        <p>
          Com o lançamento internacional da Eduzz, você terá a oportunidade de alcançar clientes ao redor do mundo e vender em diferentes moedas,
          enquanto recebe pagamentos diretamente em reais. Isso significa mais vendas, mais oportunidades e nenhuma preocupação com impostos
          estrangeiros.
        </p>
        <p>
          Além disso, você pode contar com o Multi Ofertas! Com ele, você terá a liberdade de criar ofertas com múltiplos preços em qualquer moeda
          para o mesmo produto, sem a necessidade de criar uma variação inteira. Assim você reduz suas etapas de criação, facilita a sua gestão das
          ofertas e ainda pode oferecer preços diferenciados de forma eficiente.
        </p>
        <p>
          Conheça todos os detalhes sobre o Checkout Global e aproveite os benefícios do Multi Ofertas clicando{' '}
          <a href='https://orbita.eduzz.com/producer/news/info/261' target='_blank' rel='noopener noreferrer'>
            aqui
          </a>
          .
        </p>
      </>
    ),
  },
  {
    storageKey: 'new-products-nutror-experience',
    title: 'Conheça o Nutror Experience!',
    image: '/img/news/nutror-experience.jpg',
    description: (
      <>
        <p>
          O Nutror está de cara nova! Para os produtores e estrategistas digitais que valorizam a experiência de aprendizado, estamos orgulhosos em
          apresentar o Nutror Experience.
        </p>
        <p>
          Com versão web e aplicativo, além do plugin Heycamp, o novo design elegante (estilo Netflix) e novos recursos farão você ter uma incrível
          Comunidade em seus cursos. Gere impacto com a sua marca, fidelize alunos e eleve seu Negócio a outro nível.
        </p>
        <p>
          Conheça os detalhes sobre o Nutror Experience{' '}
          <a href='https://orbita.eduzz.com/producer/news/info/262' target='_blank' rel='noopener noreferrer'>
            aqui
          </a>
          .
        </p>
      </>
    ),
  },
  {
    storageKey: 'new-products-inside-sales',
    title: 'Venda Ativa: Resultados extraordinários sem esforço! ',
    image: '/img/news/venda-ativa.jpg',
    description: (
      <>
        <p>
          Esta é uma <strong>exclusividade da Eduzz</strong>, nunca vista no mercado! Com a Venda Ativa, você empodera a sua equipe de vendas, atuando
          rapidamente nos lançamentos para aumentar a conversão.
        </p>
        <p>
          O fechamento das vendas acontece de forma prática pelo WhatsApp, sem passar pelo checkout, basta o cliente dizer &quot;sim&quot;. Menos
          esforço, mais resultados e liberdade para decolar o faturamento do seu negócio!
        </p>
        <p>
          Conheça os detalhes sobre o Venda Ativa{' '}
          <a href='https://orbita.eduzz.com/producer/news/info/263' target='_blank' rel='noopener noreferrer'>
            aqui
          </a>
          .
        </p>
      </>
    ),
  },
];
